/**
 * MudMixer Mega Menu — Multi-handle support
 * Each trigger button [data-mm-mega-trigger="handle"] pairs with
 * a panel [data-mm-mega-panel="handle"]. Panel is positioned below
 * the trigger (not full-width).
 */
(function () {
  'use strict';

  /* The theme editor can run this file again when it re-renders the header.
     One copy is enough: its shopify:section:load handler binds the new markup. */
  if (window.mmMegaMenuLoaded) return;
  window.mmMegaMenuLoaded = true;

  var HOVER_DELAY = 100;

  /* Panels marked data-mm-mega-anchor="nav" (BFCM sale header) follow the sale
     design: NAV_GAP below the nav row, centred on the nav, kept VIEWPORT_EDGE
     inside the window, with the arrow (--mm-mega-arrow-x) under the trigger. */
  var NAV_GAP = 16;
  var VIEWPORT_EDGE = 30;

  /* State lives at file level so the document/window listeners below are bound
     once, however often the header is re-rendered. */
  var overlay = null;
  var activeTrigger = null;
  var activePanel = null;
  var hoverTimeout = null;
  var closeTimeout = null;
  var headerObserver = null;
  /* Theme editor: the panel of the selected mega menu block stays open while it's selected */
  var pinnedPanel = null;

  function getPanel(handle) {
    return document.querySelector('[data-mm-mega-panel="' + handle + '"]');
  }

  function positionPanelUnderNav(trigger, panel, nav) {
    var navRect = nav.getBoundingClientRect();
    var triggerRect = trigger.getBoundingClientRect();
    var panelWidth = panel.offsetWidth || 600;
    var left = navRect.left + navRect.width / 2 - panelWidth / 2;
    left = Math.max(VIEWPORT_EDGE, Math.min(left, window.innerWidth - VIEWPORT_EDGE - panelWidth));

    panel.style.position = 'fixed';
    panel.style.top = navRect.bottom + NAV_GAP + 'px';
    panel.style.left = left + 'px';
    panel.style.setProperty('--mm-mega-arrow-x', triggerRect.left + triggerRect.width / 2 - left + 'px');
  }

  function positionPanel(trigger, panel) {
    var nav = panel.getAttribute('data-mm-mega-anchor') === 'nav' ? trigger.closest('.header__inline-menu') : null;
    if (nav) {
      positionPanelUnderNav(trigger, panel, nav);
      return;
    }

    var headerSection = document.querySelector('.section-header');
    if (!headerSection) return;

    var headerRect = headerSection.getBoundingClientRect();

    /* Fixed position, top aligned to bottom of header */
    panel.style.position = 'fixed';
    panel.style.top = headerRect.bottom + 'px';

    /* Center panel horizontally on the viewport */
    var panelWidth = panel.offsetWidth || 600;
    var left = (window.innerWidth - panelWidth) / 2;
    left = Math.max(16, left);
    panel.style.left = left + 'px';
  }

  function open(trigger) {
    if (!trigger.isConnected) return;
    var handle = trigger.getAttribute('data-mm-mega-trigger');
    var panel = getPanel(handle);
    if (!panel) return;

    clearTimeout(closeTimeout);

    /* Close any other open panel first */
    if (activePanel && activePanel !== panel) {
      closeImmediate();
    }

    activeTrigger = trigger;
    activePanel = panel;

    positionPanel(trigger, panel);
    panel.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeImmediate() {
    // Keep inline position styles in place so the panel fades out where it
    // opened. They get re-applied on the next open() via positionPanel().
    if (activePanel) activePanel.classList.remove('is-active');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('is-active');
    activeTrigger = null;
    activePanel = null;
  }

  function close() {
    clearTimeout(hoverTimeout);
    if (!activePanel || activePanel === pinnedPanel) return;
    closeImmediate();
  }

  function scheduleOpen(trigger) {
    clearTimeout(closeTimeout);
    clearTimeout(hoverTimeout);
    hoverTimeout = setTimeout(function () { open(trigger); }, HOVER_DELAY);
  }

  function scheduleClose() {
    clearTimeout(hoverTimeout);
    closeTimeout = setTimeout(close, HOVER_DELAY);
  }

  function bindTrigger(trigger) {
    if (trigger.mmMegaBound) return;
    trigger.mmMegaBound = true;

    trigger.addEventListener('mouseenter', function () { scheduleOpen(trigger); });
    trigger.addEventListener('mouseleave', scheduleClose);

    /* Keyboard focus opens the panel so keyboard users get parity with hover.
       Click/Enter on the <a> falls through to navigate to link.url. */
    trigger.addEventListener('focus', function () { scheduleOpen(trigger); });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeTrigger === trigger) {
        close();
        trigger.focus();
      }
    });
  }

  /* Keep panel open on hover */
  function bindPanel(panel) {
    if (panel.mmMegaBound) return;
    panel.mmMegaBound = true;

    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimeout); });
    panel.addEventListener('mouseleave', scheduleClose);

    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close();
        if (activeTrigger) activeTrigger.focus();
        return;
      }
      if (e.key === 'Tab') {
        var focusable = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* Binds the current header markup. Safe to call again after the theme editor
     replaces the header: bound elements are skipped and state that points at
     removed markup is dropped. */
  function initDesktopMega() {
    clearTimeout(hoverTimeout);
    clearTimeout(closeTimeout);
    if (activePanel && !activePanel.isConnected) {
      activeTrigger = null;
      activePanel = null;
    }
    if (pinnedPanel && !pinnedPanel.isConnected) pinnedPanel = null;

    overlay = document.querySelector('[data-mm-mega-overlay]');
    document.querySelectorAll('[data-mm-mega-trigger]').forEach(bindTrigger);
    document.querySelectorAll('[data-mm-mega-panel]').forEach(bindPanel);

    /* Close when Dawn hides header */
    if (headerObserver) headerObserver.disconnect();
    headerObserver = null;
    var sectionHeader = document.querySelector('.section-header');
    if (sectionHeader) {
      headerObserver = new MutationObserver(function () {
        if (sectionHeader.classList.contains('shopify-section-header-hidden')) close();
      });
      headerObserver.observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* Close on click outside trigger and panel */
  document.addEventListener('mousedown', function (e) {
    if (!activePanel) return;
    if (!e.target.closest('[data-mm-mega-trigger]') && !e.target.closest('[data-mm-mega-panel]')) {
      close();
    }
  });

  /* Reposition on scroll/resize */
  var rafId = null;
  function reposition() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      if (activeTrigger && activePanel) positionPanel(activeTrigger, activePanel);
      rafId = null;
    });
  }
  window.addEventListener('scroll', reposition, { passive: true });
  window.addEventListener('resize', reposition, { passive: true });

  /* ── Mobile accordion ───────────────────────────────────── */
  function initMobileAccordion() {
    document.querySelectorAll('[data-mm-drawer-group]').forEach(function (group) {
      var btn = group.querySelector('[data-mm-drawer-group-btn]');
      if (!btn || btn.mmMegaBound) return;
      btn.mmMegaBound = true;
      btn.addEventListener('click', function () {
        var wasOpen = group.classList.contains('is-open');
        group.parentElement.querySelectorAll('[data-mm-drawer-group]').forEach(function (g) {
          g.classList.remove('is-open');
          var b = g.querySelector('[data-mm-drawer-group-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          group.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    initDesktopMega();
    initMobileAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('[data-mm-mega-panel]')) init();
    });

    /* Selecting a mega menu block in the theme editor opens its panel (also after
       the header re-renders for a settings change), and it stays open until the
       block is deselected. */
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest && e.target.closest('[data-mm-mega-panel]');
      if (!panel) return;
      var trigger = document.querySelector('[data-mm-mega-trigger="' + panel.getAttribute('data-mm-mega-panel') + '"]');
      if (!trigger) return;
      pinnedPanel = null;
      open(trigger);
      pinnedPanel = panel;
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (!pinnedPanel || !pinnedPanel.contains(e.target)) return;
      pinnedPanel = null;
      close();
    });
  }
})();
